import { createSelector } from '@ngrx/store';
import { Status } from '@essent/common';

import { solarPanelsApiKey } from './solar-panels-api.reducer';
import { selectFehSolarPanelsState } from '../feh-solar-panels.state';

const selectSolarPanelsApiState = createSelector(
  selectFehSolarPanelsState,
  (state) => state[solarPanelsApiKey]
);

const selectGetSolarPanelsAddressCheckState = createSelector(
  selectSolarPanelsApiState,
  (state) => state.getSolarPanelsAddressCheck
);

/**
 * Address check endpoint
 */
export const selectGetSolarPanelsNewCustomerAddressCheckData = createSelector(
  selectGetSolarPanelsAddressCheckState,
  (addressCheckState) => addressCheckState.data
);

export const selectSolarPanelsProductsWithCalculations = createSelector(
  selectGetSolarPanelsNewCustomerAddressCheckData,
  (state) => state?.products
);

/**
 * Confirmation endpoint
 */

export const selectPostSolarPanelsConfirmationState = createSelector(
  selectSolarPanelsApiState,
  (state) => state.postSolarPanelsCreateLead
);

/**
 * Get expected consumption endpoint
 */
export const selectSolarPanelsExpectedConsumption = createSelector(
  selectSolarPanelsApiState,
  (state) =>
    state.getExpectedConsumption.status === Status.SUCCESS
      ? (state.getExpectedConsumption.data?.electricity?.total ?? null)
      : null
);
